<template>
	<div class="i-accordion">
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Was ist Cashback?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Cashback bedeutet ins Deutsche übersetzt „Geld zurück“ und erklärt sich somit selbst: Du bekommst beim Einkaufen in einer unseren ROMA Friseurbedarf Shops in Österreich einen Teil deines ausgegebenen Geldes zurück. Und das nicht nur aktionsweise, sondern bei jedem Einkauf werden dir 2% gutgeschrieben, ab Einkauf 49 € 4% und ab Einkauf 99 € 6%, bei allen unseren ROMA Friseurbedarf Filialen in Österreich. Voraussetzung ist, dass du eine ROMA Friseurbedarf Kundenkarte besitzt und dich auf unserer www.ROMA.at - Webseite angemeldet hast.</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Warum macht ROMA Friseurbedarf das überhaupt?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Unser Ziel ist es unseren Kund:innen das bestmögliche Einkaufserlebnis zu bieten und unser Bestreben ist es unsere Stammkund:innen zu belohnen. Aus diesen Gründen haben wir uns entschlossen, dass wir mit diesem Cashback System einen direkten Bonus an unsere treuen Kund:innen zurückgeben.</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Wie melde ich mich an?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Die Anmeldung im ROMA Friseurbedarf Cashback Portal ist kostenlos und ganz einfach: Um dich anzumelden, trägst du deine Daten ein und kannst auch gleich einen Gutschein sammeln für den nächsten Einkauf.</p>
				<p class="leading-loose xl:max-w-[75%] underline">Bitte beachte: Um dir dein Cashback Guthaben aufbuchen zu können, müssen die Pflichtfelder in deinem Konto vollständig ausgefüllt sein.</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Wo und Wann sehe ich mein gesammeltes Cashback Guthaben?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Sobald du in einer unseren ROMA Filialen eingekauft hast, wird dir dein Guthaben in deinem Cashback - Konto angezeigt, und darauffolgenden Monats gutgeschrieben.</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Gilt der Cashback Bonus auch bei Rabatten und Aktionen?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Das Cashback Guthaben wird vom Kaufbetrag errechnet! Du profitierst also wie gewohnt von Angeboten und Aktionen und bekommst zusätzlich noch Cashback!</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Ist die Cashback Karte auch mit unseren zusätzlichen Kundenkarten verwendbar?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Nein, in Kombination mit unseren zusätzlichen Kundenkarten (außer der Gutscheinkarte) ist sie nicht verwendbar.</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Wo finde ich Informationen zu den Cashback Umsätzen?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Du kannst mittels dem QR Code auf der Rückseite der Karte dein Kundenkartenkonto und den aktuellen Stand deines Cashback-Guthabens abfragen.</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Kann das Cashback Guthaben verfallen?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Nein, dein Cashback Guthaben verfällt nicht! Du erhältst es automatisch einmal im Monat auf dein Konto gutgeschrieben und kannst dann frei darüber verfügen!</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Muss ich einen Mindestumsatz tätigen bzw. bin ich zur Nutzung verpflichtet?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Nein, 2% bei jedem Einkauf, ab Einkauf 49 € 4% und ab Einkauf 99 € 6%. Die Nutzung von unserem Cashback System ist an keinerlei Verpflichtungen wie das Erreichen eines Mindestumsatzes gebunden! Du profitierst von Cashback, wann immer du es möchtest!</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Macht es einen Unterschied, ob ich meinen Einkauf mit Kreditkarte, Bar oder anderen Zahlungsmitteln begleiche?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Nein. Die Zahlungsart richtet sich ganz nach deinen Wünschen. deine Umsätze werden in jedem Fall berücksichtigt.</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Wie wird mein Cashback Guthaben aufgebucht?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Wir schreiben dir dein bestätigtes Cashback Guthaben automatisch zum 1. jeden Monats auf dein Kartenkonto, auf das du dann frei bei deinem nächsten Einkauf verfügen kannst.</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Bekomme ich in allen ROMA Friseurbedarf Filialen das Cashback Guthaben eingelöst?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Ja, du kannst in allen österreichischen ROMA Friseurbedarf Filialen, inklusive dem angeschlossenen Premium Shop PREMIUM EXTENSIONS chaarmant dein Cashback Guthaben einlösen.</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Wie kann ich Euch kontaktieren?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Du kannst uns jederzeit unter folgender E-Mail-Adresse erreichen: <a href="mailto:info@roma.at" class="underline text-secondary">info@roma.at</a>. Damit wir deine Anfragen schnellstmöglich beantworten können, schicke uns bitte deine Kundenkartennummer und die E-Mail-Adresse mit, mit der du dich angemeldet hast. Wir melden uns so rasch wie möglich bei dir.</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Was kann ich tun, wenn ich meine Karte verliere?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Hole dir einfach eine neue Karte in einem unserer Shops und schreib uns eine E-Mail mit deiner alten und neuen Kartennummer und deiner E-Mail-Adresse an <a href="mailto:info@roma.at" class="underline text-secondary">info@roma.at</a>. Dein bisher gesammeltes Guthaben wird selbstverständlich auf die neue Karte übertragen.</p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Warum kostet die Karte 1 €?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Unsere Kundenkarte besteht zu 100% aus recyceltem Plastik, und davon zu 99% aus Ozean-Plastik. Die Kosten einer Karte aus Ozean-Plastik sind deutlich höher als bei herkömmlichen Kunststoffkarten. Im Zuge unserer Nachhaltigkeitsstrategie haben wir uns aber entschlossen, hier doch ein Zeichen zu setzen. Zusätzlich haben wir uns entschlossen, benachteiligte Frauen mit einem Teil dieses Betrages zu unterstützen. Diese Unterstützung übergeben wir jährlich zum World Women’s Day an die nominierten Personen. Alle Details siehe unter <a href="https://worldwomensday.eu" target="_blank" rel="noopener noreferrer" class="text-secondary underline">www.worldwomensday.eu</a></p>
			</div>
		</div>
		<div class="i-question group">
			<div class="i-title" @click.self="toggleQuestion($event);">
				<span>Wie kann ich mein Konto löschen?</span>
				<i class="i-icon fa-light fa-plus fa-xl"></i>
				<i class="i-icon i-icon-open fa-light fa-minus fa-xl"></i>
			</div>
			<div class="i-answer">
				<p class="leading-loose xl:max-w-[75%]">Schreibe einfach eine Nachricht an <a href="mailto:info@roma.at" class="underline text-secondary">info@roma.at</a> mit deiner Kundenkartennummer und deiner registrierten E-Mail-Adresse. Dein Konto wird innerhalb von 7 Tagen gelöscht. Eventuell noch bestehendes Cashback Guthaben verfällt zu diesem Zeitpunkt.</p>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const CLEAR_OPEN = false;

const toggleQuestion = (event) => {
	console.log("toggleQuestion", event.target);
	let question = event.target.closest('.i-question');
	const open = question.classList.contains('open');
	console.log("open", open);
	clearOpenClasses();
	if (!open) {
		question.classList.add('open');
	} else {
		question.classList.remove('open');
	}
}

const clearOpenClasses = () => {
	if (!CLEAR_OPEN) return;
	let questions = document.querySelectorAll('.i-question.open');
	console.log("clearOpenClasses", questions);
	questions.forEach((question) => {
		question.classList.remove('open');
	});
}

onMounted(() => {
	console.log("iCordion mounted");
});
</script>

<style lang="scss" scoped>
	.i-accordion {
		@apply flex flex-col gap-y-1;

		.i-question {
			@apply overflow-hidden border-b border-primary/40 hover:border-primary transition-all duration-300;
			.i-title {
				@apply cursor-pointer py-4 gap-x-2 flex items-center justify-between text-lg hover:font-bold hover:text-primary;

				* {
					@apply pointer-events-none select-none;
				}

				.i-icon {
					@apply transition-all ease-linear text-primary;
					&.i-icon-open {
						@apply hidden;
					}
				}
			}

			.i-answer {
				@apply scale-y-0 h-0 origin-top block text-black transition-all ease-linear overflow-hidden;

				p {
					@apply py-4;
				}
			}

			&.open {
				@apply border-primary border-b-2;
				.i-title {
					@apply text-primary font-bold;
					.i-icon {
						@apply hidden;
						&.i-icon-open {
							@apply block;
						}
					}
				}
				.i-answer {
					@apply scale-y-100 h-auto;
				}
			}
		}
	}
</style>
